
      import Moment from './moment.vue'
      import type { App, Plugin } from 'vue'

      export const MomentPlugin: Plugin = {
        install(app: App) {
          app.component('Moment', Moment)
        },
      }
      export { Moment }
      